import { ControlType, FetchStatus } from "../../../../base/types";
import { EnumLabelProperties, useEnumLabelProperties } from "./EnumLabelProperties";
import { ErrorMessage, Spinner } from "../../../../widgets";

import { DraftEnumLabelComponent } from "./DraftEnumLabelComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Label } from "../../../../widgets/Label";
import { Registry } from "../../../../base/register";
import clsx from "clsx";

export const EnumLabelComponent: FC<IControlAttributes> = ({
    control, className, children, designerMode, props, ...rest
}) => {
    const { status, properties, error } = useEnumLabelProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) {
        return <></>;
    }

    const { classNames } = properties;

    return (
        <Label
            className={clsx(className, classNames)}
            iconClassName="me-1"
            {...properties}>
            {children}
        </Label>
    );
}

Registry.addControl({
    id: "b3803db5-9971-4d41-9714-71df596415b2",
    name: "Enum Label",
    type: ControlType.EnumLabel,
    properties: EnumLabelProperties,
    component: EnumLabelComponent,
    draftComponent: DraftEnumLabelComponent
})
